import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
import LoadingOverlay from 'framework-asset-preview-lib/internal/shared/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
export default Loadable({
  loader: () => import( /* webpackChunkName: "call-preview-popover" */'./CallPopover').then(mod => mod.default).catch(AsyncComponentErrorHandler('call-preview-popover')),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingOverlay, {
    previewType: "popover"
  })
});